import React from 'react';

interface NewRatnaIconProps {
  width?: number;
  height?: number;
  colorPrimary?: string;
  colorSecondary?: string;
  ref?: React.Ref<SVGSVGElement>;
}

const NewRatnaIcon: React.FC<NewRatnaIconProps> = React.forwardRef(
  ({ width = 50, height = 50, colorPrimary = "#7F38E9", colorSecondary = "#BF9CF4" }, ref) => {
    return (
      <svg width={width} height={height} ref={ref} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
          <path
            d="M25.0028 24.0055C24.7213 24.0055 24.4399 23.8982 24.2253 23.6835L15.322 14.7802C15.1159 14.5739 15 14.2944 15 14.0027C15 13.7112 15.1159 13.4316 15.322 13.2253L24.2254 4.32206C24.44 4.10738 24.7214 4 25.0029 4C25.2842 4 25.5656 4.10729 25.7802 4.32206L34.6836 13.2253C34.8897 13.4316 35.0056 13.7112 35.0056 14.0027C35.0056 14.2944 34.8897 14.5739 34.6836 14.7802L25.7802 23.6835C25.5655 23.8982 25.284 24.0055 25.0028 24.0055Z"
            fill={colorPrimary}
          />
          <path
            d="M15.3188 14.7817L24.2221 23.685C24.42 23.8829 24.6746 23.9884 24.9335 24.0038L24.9336 14.0703H15C15.0161 14.3378 15.1282 14.5911 15.3188 14.7817Z"
            fill={colorSecondary}
          />
          <path
            opacity="0.1"
            d="M18.3032 14.7801C18.0971 14.5738 17.9812 14.2943 17.9812 14.0027C17.9812 13.7111 18.097 13.4315 18.3032 13.2252L26.4933 5.03518L25.7802 4.32206C25.5655 4.10738 25.2841 4 25.0028 4C24.7213 4 24.4399 4.10729 24.2253 4.32206L15.322 13.2253C15.116 13.4316 15 13.7112 15 14.0027C15 14.2944 15.1159 14.5739 15.322 14.7802L24.2254 23.6835C24.44 23.8982 24.7214 24.0055 25.0029 24.0055C25.2842 24.0055 25.5656 23.8982 25.7802 23.6835L26.4934 22.9704L18.3032 14.7801Z"
            fill="#212121"
          />
          <path
            d="M34.6824 13.2236L25.7791 4.32028C25.5739 4.11511 25.3078 4.00915 25.0391 4V13.9635H35.0025C34.9931 13.6858 34.8797 13.421 34.6824 13.2236Z"
            fill={colorSecondary}
          />
          <path
            d="M25.0054 17.9793C24.8647 17.9793 24.7239 17.9256 24.6166 17.8182L21.1923 14.3939C21.0892 14.2908 21.0312 14.1509 21.0312 14.0052C21.0312 13.8593 21.0892 13.7196 21.1923 13.6165L24.6166 10.1922C24.7239 10.0849 24.8647 10.0312 25.0054 10.0312C25.1459 10.0312 25.2867 10.0849 25.3941 10.1922L28.8185 13.6165C28.9215 13.7196 28.9794 13.8595 28.9794 14.0052C28.9794 14.151 28.9215 14.2907 28.8185 14.3939L25.3941 17.8182C25.2866 17.9256 25.146 17.9793 25.0054 17.9793Z"
            fill={colorSecondary}
          />
        </g>
        <defs>
          <filter id="filter0_d" x="-3.47619" y="-3.61905" width={width} height={height} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="10.8571" />
            <feGaussianBlur stdDeviation="7.23809" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.450981 0 0 0 0 0.341177 0 0 0 0 0.913725 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
        </defs>
      </svg>
    );
  }
);

export default NewRatnaIcon;
